<template>
  <div class="d-flex align-items-stretch com-split-wrap quick-filter-wrap gap-3 flex-wrap p-0" :class="$attrs.class">
    <div class="d-flex flex-wrap max-width">
      <!-- Rep Dropdown -->
      <div class="label-dropdown position-relative">
        <button class="dropdown-toggle text-capitalize" type="button" @click="toggleRepDropdown">
          {{ selectedLabel }}
        </button>
        <ul v-if="dropdownOpen" class="dropdown-menu show" style="position: absolute; top: 70%; z-index: 10">
          <li v-for="(label, index) in labels" :key="index" :class="{ 'selected-option': label === selectedLabel }">
            <a class="dropdown-item" href="#" @click.prevent="selectLabel(label)">
              {{ label }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Input -->
      <div class="dropdown-input-wrap position-relative flex-grow-1">
        <input type="text" class="dropdown-input w-100 pe-5" :placeholder="placeholders[selectedLabel]"
          v-model="inputValue" @keyup.enter="triggerSearch" />
        <i class="fa fa-search position-absolute text-muted" style="
            top: 50%;
            right: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
          "></i>
      </div>
    </div>

    <!-- Status Dropdown -->
    <div class="position-relative status-dropdown-wrap">
      <button class="dropdown-toggle status-dropdown" type="button" @click="toggleStatusDropdown">
        Status : {{ selectedStatus }}
      </button>
      <ul v-if="statusDropdownOpen" class="dropdown-menu show w-100"
        style="position: absolute; top: 70%; left: 0; z-index: 10">
        <li class="dropdown-item" :class="{ 'active': selectedStatus === 'All' }" style="cursor: pointer"
          @click="selectStatus('All')">
          <span>All Status</span>
        </li>
        <li class="dropdown-item enable-txt stat-text" :class="{ 'active': selectedStatus === 'Enable' }"
          style="cursor: pointer" @click="selectStatus('Enable')">
          <span class="enable-dot"></span>Enable
        </li>
        <li class="dropdown-item disable-txt stat-text" :class="{ 'active': selectedStatus === 'Disable' }"
          style="cursor: pointer" @click="selectStatus('Disable')">
          <span class="disable-dot"></span>Disable
        </li>
      </ul>
    </div>

    <div class="date-picker-wrapper">
      <DatePicker v-model="effectiveDate" @input="onDateChange" :format="'YYYY-MM-DD'" />
    </div>
    
    <button class="univ-btn m-0" @click="triggerSearch">Search</button>
    <button class="clearBtn" @click="clearAll">Clear</button>

  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
export default {
  name: "QuickFilterInput",
  components: { DatePicker },
  props: {
    labels: {
      type: Array,
      default: () => ["To Rep name", "Seller Rep name"],
    },
    placeholders: {
      type: Object,
      default: () => ({
        "To Rep name": "Enter To Rep name",
        "Seller Rep name": "Enter Seller Rep name",
      }),
    },
  },

  data() {
    return {
      selectedLabel: this.labels[0] || "",
      inputValue: "",
      effectiveDate: "",
      dropdownOpen: false,
      statusDropdownOpen: false,
      selectedStatus: "All",
    };
  },
  methods: {
    onDateChange(date) {
      this.effectiveDate = date;
      this.$emit('loading', true);
      setTimeout(() => {
        this.triggerSearch();
      }, 50);
    },
    clearDate() {
      this.effectiveDate = '';
      this.triggerSearch();
    },
    toggleRepDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      this.statusDropdownOpen = false;
    },
    toggleStatusDropdown() {
      this.statusDropdownOpen = !this.statusDropdownOpen;
      this.dropdownOpen = false;
    },
    selectStatus(status) {
      this.selectedStatus = status === 'All' ? 'All' : status;
      this.statusDropdownOpen = false;
      this.triggerSearch();
    },
    selectLabel(label) {
      this.selectedLabel = label;
      this.inputValue = "";
      this.dropdownOpen = false;
    },
    triggerSearch() {
      let statusValue = '';
      if (this.selectedStatus === 'Enable') {
        statusValue = '1';
      } else if (this.selectedStatus === 'Disable') {
        statusValue = '0';
      }

      this.$emit("search", {
        label: this.selectedLabel,
        value: this.inputValue,
        status: statusValue,
        effective_date: this.effectiveDate
      });
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false;
        this.statusDropdownOpen = false;
      }
    },
    clearAll() {
      this.selectedLabel = this.labels[0] || "";
      this.inputValue = "";
      this.effectiveDate = "";
      this.selectedStatus = "All";
      this.triggerSearch();
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style scoped>
.status-dropdown {
  max-width: fit-content;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 0.7rem 1rem;
  background: #fff;
}
.dropdown-menu {
  max-width: fit-content;
}
.form-input-max {
  max-width: 250px;
  min-width: 250px;
}
.dropdown-input-wrap {
  min-width: 250px;
  max-width: 500px;
  background: #fafbfd;
}
.quick-filter-wrap {
  /* max-height: 50px; */
  margin-bottom: 1rem;
}
.quick-filter-wrap .label-dropdown {
  border: none;
  border-radius: 0;
  max-width: fit-content;
}
.quick-filter-wrap .label-dropdown button {
  border: none;
  border-radius: 6px 0 0 6px;
  background: #f3f3f3;
  color: #254050;
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: 600;
}
.label-dropdown button:hover,
.label-dropdown button:active {
  border: none !important;
}
.quick-filter-wrap .dropdown-menu {
  padding: 0;
}
.quick-filter-wrap .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  padding: 0.5rem 0.8rem;
}
.quick-filter-wrap .dropdown-menu.show {
  border: 1px solid #CED4DA;
  padding: 0.3rem;
  border-radius: 0 0 6px 6px;
  top: 69% !important;
}
.quick-filter-wrap .dropdown-menu li:first-child {
  padding-bottom: 3px;
}
.quick-filter-wrap .dropdown-menu .selected-option a {
  color: #03c6ec;
  font-weight: 400;
}
.quick-filter-wrap .dropdown-input {
  border: none;
  border-radius: 0 6px 6px 0;
  background-color: #fafbfd;
  font-size: 14px;
  padding: 0.75rem 1rem;
  height: 100%;
}
.quick-filter-wrap .dropdown-input:focus {
  border: none;
}

.max-width {
  max-width: fit-content;
}

.clearBtn {
  width: 15%;
  text-align: center;
  background: #ea584e1a;
  border: 1px solid #ea584e;
  color: #ea584e;
  padding: 9px;
  border-radius: 6px;
  margin-left: 5px;
  font-size: 15px;
  transition: all ease 0.4s;
  color: #ea584e;
}
</style>

<style>
@media (max-width: 576px) {
  .quick-filter-wrap .label-dropdown,
  .quick-filter-wrap .label-dropdown button{
    width: 100% !important;
    max-width: none !important;
  }
  .quick-filter-wrap .label-dropdown button{
    border-radius: 6px 6px 0 0 !important;
  }
  .quick-filter-wrap .dropdown-input-wrap{
    min-width: 230px !important;
  }
  .com-split-wrap .date-picker-wrapper,
  .com-split-wrap .date-input,
  .status-dropdown-wrap,
  .com-split-wrap .status-dropdown,
  .com-split-wrap .univ-btn,
  .com-split-wrap .clearBtn {
    width: 100% !important;
    max-width: none !important;
  }
}
</style>